<template>
<div class="field file-padded-bottom-border" style="padding-bottom: 1.5rem;">
	<div class="control">
			<div class="columns">
					<div class="column is-6">
						<label>Upload Files</label>
							<file-uploader :vuexStore="fileUploadStore" :vuexUploadAction="fileUploadAction" :buttonName="buttonName" :vuexSelectAction="fileSelectAction" :setDescription="setDescription"></file-uploader>
					</div>
					
					<cliploader :loading="showUploadLoader" :size="size" class="upload-file"></cliploader>
			</div>
	</div>
</div>
</template>
<script>
import { mapState } from "vuex";

export default {
	data(){
		return {
			size: '50px',
			fileUploadStore: "vendorComplianceDetails",
			fileSelectAction: "canUploadFile",
			fileUploadAction: "uploadFile",
			setDescription: false,
			buttonName: "+ Upload",
		}
	},
	computed: {
		...mapState('vendorComplianceDetails', {
			showUploadLoader: state => state.showUploadLoader
		})
	}
}
</script>

<!-- The app-wide .upload-button style is a muted gray outline that blends
     into the page; make this "+ Upload" button a solid blue button instead. -->
<style>
.file-padded-bottom-border .upload-button{
	color: #fff !important;
	background-color: #5179D6 !important;
	border: 1px solid #5179D6 !important;
}

.file-padded-bottom-border .upload-button:hover{
	background-color: #3F66BD !important;
	border-color: #3F66BD !important;
}
</style>
